import type { FC } from 'react';

import '@data/Simulations/pipeline/blocks/MapBlock';

type MapParametersProps = {
    blockId: string;
};

const MapParameters: FC<MapParametersProps> = () => null;

export default MapParameters;
